import React, { ReactNode, FC } from "react";
import Navbar from "./partials/Navbar";
import Footer from "./partials/Footer";
import { Provider } from "../lib/auth/Provider";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "../state/store";
import { Toaster } from "@/components/ui/sonner";
import { HeadFC } from "gatsby";

interface Props {
  children: ReactNode;
}

const Layout: FC<Props> = ({ children }) => {
  return (
    <ReduxProvider store={store}>
      <Provider>
        <div className="h-screen">
          <Navbar />
          <div className="content min-h-100">{children}</div>
          <Toaster
            toastOptions={{
              classNames: {
                description: "!text-red-900",
              },
            }}
          />
          <Footer />
        </div>
      </Provider>
    </ReduxProvider>
  );
};

// Add a responsive meta tag to the head of the document
export const Head: HeadFC = () => (
  <>
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  </>
);

export default Layout;
